import getScheduleRequest from "./requests/get-schedule-request";
import setScheduleRequest from "./requests/set-schedule-request";
import deletePlannerRequest from "./requests/delete-planner-request";
import setPlannerRequest from "./requests/set-planner-request";
import getPlannerRequest from "./requests/get-planner-request";
import getPopularRequest from "./requests/get-popular-request";

const scheduleRepository = {
    getSchedule: getScheduleRequest,
    setSchedule: setScheduleRequest,
    deletePlanner: deletePlannerRequest,
    setPlanner: setPlannerRequest,
    getPlanner: getPlannerRequest,
    getPopular: getPopularRequest,
};

export default scheduleRepository;